import type { PublicSlotKey } from '#packages/apilib';
import type { WorkspaceApi } from './api';

export const WorkspaceApiKey: PublicSlotKey<WorkspaceApi> = {
  name: 'Workspace API',
  public: true,
};
